import * as path from "path";
import { appConfig } from "../../config";
import { IEnvironment } from "../../models";

export function getEnvironment(): IEnvironment {
	let environmentKey = getEnvironmentKey();
	return appConfig.envDetails[environmentKey];
}

export function getEnvironmentKey() {
	return process.env.NODE_ENV;
}

export function getUrlParameter(url: string, name: string) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	let results = regex.exec(url);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getbaseURL() {
	let environment = getEnvironment();
	return environment.baseurl;
}


// WEBPACK FOOTER //
// ./src/client/utils/url.ts